import React from 'react'
import Settlement from '../../Brands/Settlement/Settlement'

function OutletSettlement() {
  return (
    <div><Settlement props={"outlet"}/></div>
  )
}

export default OutletSettlement